<div class="horizontal-box-list">
  <ng-content/>
</div>
